import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeMenuModule } from 'se-fe-menu'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiProfileSidePanelModule } from '../lib/shared-ui-profile-side-panel.module'
import {
  ProfileSidePanelDocsComponent
} from './profile-side-panel-docs/profile-side-panel-docs.component'
import {
  ProfileSidePanelExampleComponent
} from './profile-side-panel-docs/profile-side-panel-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFeMenuModule,
    SeFePageModule,
    SharedUiProfileSidePanelModule
  ],
  declarations: [
    ProfileSidePanelDocsComponent,
    ProfileSidePanelExampleComponent
  ],
  exports: [
    ProfileSidePanelDocsComponent
  ]
})
export class SharedUiProfileSidePanelDocsModule {}
